(() => {
  const configNode = document.getElementById('adored-cart-rewards-config');
  if (!configNode || window.AdoredCartRewards) return;
  const config = JSON.parse(configNode.textContent);
  if (!config.variantId) return;
  const nativeFetch = window.fetch.bind(window);
  const root = config.root.endsWith('/') ? config.root : config.root + '/';
  let queue = Promise.resolve();
  let pending = 0;
  let lastError = '';
  let checkoutReady = false;
  const managed = item => item.properties?._adored_gift === 'bee' && Number(item.variant_id) === Number(config.variantId);
  const paid = cart => cart.items.some(item => !managed(item) && item.original_line_price > 0);
  const giftFingerprint = cart => JSON.stringify({
    items: cart.items.filter(item => !managed(item)).map(item => [item.variant_id, item.quantity]).sort((a,b) => a[0]-b[0]),
    codes: (cart.discount_codes || []).map(item => item.code.toLowerCase()).sort()
  });
  const request = async (path, body) => {
    const response = await nativeFetch(root + 'cart/' + path, {
      method: 'POST', headers: {'Content-Type':'application/json'},
      body: JSON.stringify(body), signal: AbortSignal.timeout(12000)
    });
    const data = await response.json();
    if (!response.ok || data.errors || data.status >= 400) throw new Error(data.description || 'Cart request failed');
    return data;
  };
  const read = async () => {
    const response = await nativeFetch(root + 'cart.js', {cache:'no-store',signal:AbortSignal.timeout(12000)});
    if (!response.ok) throw new Error('Cart could not be read');
    return response.json();
  };
  const error = message => {
    lastError = message;
    document.querySelectorAll('[data-adored-gift-error]').forEach(node => {
      node.textContent = message;
      node.hidden = !message;
    });
    if (message) document.querySelectorAll('[data-adored-gift-status]').forEach(node => node.hidden = true);
  };
  const serial = task => {
    pending++;
    const result = queue.then(task);
    queue = result.catch(() => {}).finally(() => { pending--; });
    return result;
  };
  const reconcile = async initial => {
    let cart = initial || await read();
    let changed = false;
    const gifts = cart.items.filter(managed);
    const wantsGift = paid(cart) && cart.attributes?._adored_gift_declined !== 'yes' && config.available;
    const fingerprint = giftFingerprint(cart);
    const blocked = cart.attributes?._adored_gift_blocked === fingerprint;
    if (cart.attributes?._adored_gift_blocked && (!blocked || !wantsGift)) {
      cart = await request('update.js', {attributes:{_adored_gift_blocked:'',_adored_gift_status:''}});
      changed = true;
    }
    const updates = {};
    gifts.forEach((item, index) => {
      const quantity = wantsGift && index === 0 ? 1 : 0;
      if (item.quantity !== quantity) updates[item.key] = quantity;
    });
    if (Object.keys(updates).length) {
      cart = await request('update.js',{updates});
      changed = true;
    }
    if (wantsGift && !blocked && !cart.items.some(managed)) {
      try {
        await request('add.js',{items:[{id:config.variantId,quantity:1,properties:{_adored_gift:'bee'}}]});
        cart = await read();
        changed = true;
      } catch (e) {
        cart = await read();
        cart = await request('update.js', {attributes:{_adored_gift_blocked:giftFingerprint(cart),_adored_gift_status:'retry'}});
        changed = true;
        error(config.giftError);
      }
    }
    const chargedGifts = cart.items.filter(item => managed(item) && item.final_line_price > 0);
    if (chargedGifts.length) {
      cart = await request('update.js',{updates:Object.fromEntries(chargedGifts.map(item => [item.key,0]))});
      cart = await request('update.js', {attributes:{_adored_gift_blocked:giftFingerprint(cart),_adored_gift_status:'offer_conflict'}});
      changed = true;
      error(config.giftConflict);
    } else if (blocked && wantsGift && !cart.items.some(managed)) {
      error(cart.attributes?._adored_gift_status === 'offer_conflict' ? config.giftConflict : config.giftError);
    } else if (!wantsGift || cart.items.some(managed)) {
      error('');
    }
    return {cart,changed};
  };
  const sections = () => {
    if (window.Alpine?.store('xCartHelper')) return window.Alpine.store('xCartHelper').getSectionsToRender();
    const main = document.getElementById('main-cart-items');
    if (main) {
      return ['main-cart-items','main-cart-footer','cart-icon-bubble','mobile-cart-icon-bubble'].map(id => {
        const element = document.getElementById(id);
        return {id:element?.closest('.shopify-section')?.id.replace('shopify-section-','') || id,selector:'#'+id};
      });
    }
    return [{id:'cart-drawer',selector:'#CartDrawer'},{id:'cart-icon-bubble',selector:'#cart-icon-bubble'},{id:'mobile-cart-icon-bubble',selector:'#mobile-cart-icon-bubble'}];
  };
  const refresh = async () => {
    const targets = sections();
    const ids = [...new Set(targets.map(section => section.id))].slice(0,5);
    const url = new URL(window.location.href);
    url.searchParams.set('sections',ids.join(','));
    const response = await nativeFetch(url,{cache:'no-store'});
    const html = await response.json();
    targets.forEach(section => {
      const target = document.querySelector(section.selector);
      const source = html[section.id] && new DOMParser().parseFromString(html[section.id],'text/html').querySelector(section.selector);
      if (target && source) target.innerHTML = source.innerHTML;
    });
    error(lastError);
  };
  window.fetch = function(input, init) {
    let url;
    try { url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, window.location.href); }
    catch { return nativeFetch(input,init); }
    const method = (init?.method || (input instanceof Request ? input.method : 'GET')).toUpperCase();
    if (url.origin !== location.origin || method !== 'POST' || !/\/cart\/(add|change|update|clear)(\.js)?$/.test(url.pathname)) return nativeFetch(input,init);
    return serial(async () => {
      const response = await nativeFetch(input,init);
      if (!response.ok) return response;
      let payload;
      try { payload = await response.clone().json(); } catch { return response; }
      if (payload.errors || payload.status >= 400) return response;
      try {
        const result = await reconcile(payload.token && Array.isArray(payload.items) ? payload : undefined);
        if (!result.changed) return response;
        let replacement = result.cart;
        if (payload.sections) {
          replacement = await request('update.js',{updates:{},sections:Object.keys(payload.sections).slice(0,5),sections_url:location.pathname});
        }
        const isAdd = /\/add(\.js)?$/.test(url.pathname);
        const body = isAdd ? {...payload,sections:replacement.sections} : {...payload,...replacement};
        return new Response(JSON.stringify(body),{status:response.status,headers:{'Content-Type':'application/json'}});
      } catch (e) {
        error(config.giftError);
        return response;
      }
    });
  };
  const sync = () => serial(async () => {
    const result = await reconcile();
    if (result.changed) await refresh();
    return result.cart;
  });
  const groupKeys = input => (input?.dataset.adoredGroupKeys || '').split(',').filter(Boolean);
  const changeGroup = (input, desired) => {
    const keys = groupKeys(input);
    if (!Number.isInteger(desired) || desired < 0) return;
    if (input.dataset.adoredTracked && input.dataset.adoredPolicy === 'deny' && desired > Number(input.dataset.adoredMax)) {
      input.value = input.dataset.adoredTotal;
      return;
    }
    input.closest('.cart-item').setAttribute('aria-busy','true');
    serial(async () => {
      let cart = await read();
      const group = cart.items.filter(item => keys.includes(item.key));
      const total = group.reduce((sum,item) => sum + item.quantity,0);
      if (!group.length) { await refresh(); return; }
      if (desired === 0) {
        await request('update.js',{updates:Object.fromEntries(group.map(item => [item.key,0]))});
      } else if (desired > total) {
        const first = group[0];
        await request('add.js',{items:[{id:first.variant_id,quantity:desired-total,properties:first.properties,selling_plan:first.selling_plan_allocation?.selling_plan?.id}]});
      } else if (desired < total) {
        let remove = total-desired;
        for (const item of group) {
          const decrease = Math.min(remove,item.quantity);
          if (decrease) await request('change.js',{id:item.key,quantity:item.quantity-decrease});
          remove -= decrease;
          if (!remove) break;
        }
      }
      await reconcile();
      await refresh();
    }).catch(() => error(config.giftError)).finally(() => input.closest('.cart-item')?.removeAttribute('aria-busy'));
  };
  document.addEventListener('change',event => {
    const input = event.target.closest('input[data-adored-group-keys]');
    if (groupKeys(input).length < 2) return;
    event.stopImmediatePropagation();
    changeGroup(input,Number(input.value));
  },true);
  document.addEventListener('click', event => {
    const quantityButton = event.target.closest('.cart-item button');
    const groupInput = quantityButton?.closest('.cart-item').querySelector('input[data-adored-group-keys]');
    const action = quantityButton?.getAttribute('@click.prevent') || '';
    if (groupKeys(groupInput).length > 1 && /^(plusItemQty|minusItemQty|removeItem)\(/.test(action)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const current = Number(groupInput.dataset.adoredTotal);
      changeGroup(groupInput,action.startsWith('removeItem') ? 0 : Math.max(0,current + (action.startsWith('plusItemQty') ? 1 : -1)));
      return;
    }
    const remove = event.target.closest('[data-adored-remove-gift]');
    const add = event.target.closest('[data-adored-add-gift]');
    if (remove || add) {
      event.preventDefault();
      (remove || add).disabled = true;
      serial(async () => {
        await request('update.js',{attributes:{_adored_gift_declined:remove ? 'yes' : '',_adored_gift_blocked:'',_adored_gift_status:''}});
        await reconcile();
        await refresh();
      }).catch(() => { error(config.giftError); (remove || add).disabled = false; });
      return;
    }
    const checkout = event.target.closest('button[name="checkout"],input[name="checkout"],a[href="/checkout"],a[href="'+root+'checkout"]');
    if (!checkout || checkoutReady) { checkoutReady = false; return; }
    event.preventDefault();
    event.stopImmediatePropagation();
    checkout.setAttribute('aria-busy','true');
    serial(async () => {
      const result = await reconcile();
      if (result.cart.items.some(item => managed(item) && item.final_line_price > 0)) throw new Error('Gift is not free');
      if (!paid(result.cart)) { await refresh(); return; }
      checkoutReady = true;
      checkout.click();
    }).catch(() => error(config.checkoutError)).finally(() => checkout.removeAttribute('aria-busy'));
  },true);
  window.addEventListener('pageshow', event => { if (event.persisted) sync().catch(() => error(config.giftError)); });
  window.AdoredCartRewards = {sync,get pending(){return pending;}};
  sync().catch(() => error(config.giftError));
})();

